import * as React from "react";
import PropTypes from "prop-types";
import Raven from "raven-js";

export default class ErrorHandler extends React.Component {
  static propTypes = {
    children: PropTypes.element,
    fallback: PropTypes.element,
  };

  static defaultProps = {
    fallback: null,
  };

  state = { error: false };

  componentDidCatch(error) {
    console.error(error);
    Raven.captureException(error);
    this.setState({ error: true });
  }

  render() {
    if (this.state.error) {
      return this.props.fallback;
    } else {
      return this.props.children;
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/ErrorHandler.jsx